module.exports = __webpack_public_path__ + "static/media/icon-ev.fe104bdb.svg";